<template>
  <v-container fluid pa-5>
    <v-layout row wrap ma-0>
      <v-flex xs12 mb-3>
        <!-- <v-layout row wrap ma-0 class="headline">

        </v-layout>-->
        <p class="title text-left primary--text font-weight-medium">
          แบบรายงานข้อมูลอุบัติเหตุทางราง - การรถไฟแห่งประเทศไทย
        </p>
        <v-divider></v-divider>
      </v-flex>
      <v-flex
        :class="{
          xs4: $vuetify.breakpoint.width >= 535,
          xs6: $vuetify.breakpoint.width < 535 && $vuetify.breakpoint.width >= 400,
          xs12: $vuetify.breakpoint.width < 400,
          'pr-1': $vuetify.breakpoint.width >= 400
        }"
      >
        <p class="body-2 mb-1">วันที่รายงาน</p>
        <DatePicker v-model="reportDate" ref="reportDate" readonly />
      </v-flex>
      <v-flex
        :class="{
          xs4: $vuetify.breakpoint.width >= 535,
          xs6: $vuetify.breakpoint.width < 535 && $vuetify.breakpoint.width >= 400,
          xs12: $vuetify.breakpoint.width < 400,
          'mt-2': $vuetify.breakpoint.width < 400,
          'pl-1': $vuetify.breakpoint.width >= 400
        }"
        v-show="false"
      >
        <p class="body-2 mb-1">จังหวัด</p>
        <v-select
          v-model="reportProvinceSelect"
          :items="provinceItems"
          item-text="name"
          no-data-text="ไม่พบข้อมูล"
          label="เลือกจังหวัด"
          class="card-border"
          return-object
          flat
          solo
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs12 mt-10>
        <!-- 1 -->
        <v-layout row wrap class="ma-0 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">1</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                วัน-เวลาเกิดเหตุ
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12>
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm4
                mt-2
              >
                <p class="body-2 font-weight-medium mb-0 d-flex align-self-center">
                  วันที่
                  <span class="remark">**</span>
                </p>
                <DatePicker ref="accidentDate" v-model="date" />
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400,
                  'mt-2': $vuetify.breakpoint.width < 400
                }"
                sm4
                mt-2
              >
                <p class="body-2 font-weight-medium mb-0 d-flex align-self-center">
                  เวลา
                  <span class="remark">**</span>
                </p>
                <TimePicker ref="accidentTime" v-model="time" />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 2 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">2</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                รถที่เกิดเหตุ
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12>
            <div class="topic-line hidden"></div>
            <v-flex xs12 sm8 md6 mt-2 class="d-flex flex-row">
              <v-flex>
                <p class="body-2 font-weight-medium mb-0">
                  เลือกขบวนรถ
                  <span class="remark">**</span>
                </p>
                <v-autocomplete
                  v-model="trainSelect"
                  :items="trainItems"
                  class="card-border"
                  no-data-text="ไม่พบข้อมูล"
                  item-text="id"
                  placeholder="เลือก"
                  flat
                  solo
                  hide-details
                  return-object
                  :menu-props="{ value: trainSelectMenu, closeOnContentClick: true }"
                  @click="trainSelectMenu = true"
                  @blur="
                    e => autocompleteOnBlur('trainSelect', trainItems[0], 'trainSelectMenu', e)
                  "
                ></v-autocomplete>
                <p v-show="trainSelectText !== ''" class="body-2 mt-1 font-weight-regular mb-0">
                  <span v-if="trainSelect != null && trainSelect.id == 'ขบวนอื่นๆ'" class="remark"
                    >กรุณากรอกรายละเอียดเพิ่มเติม (ข้อ 10)</span
                  >
                  <span v-else>{{ trainSelectText }}</span>
                </p>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-layout>
        <!-- 3 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">3</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                สถานที่เกิดเหตุ
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12>
            <div class="topic-line" :class="{ 'line-mobile': $vuetify.breakpoint.xsOnly }"></div>
            <v-flex xs12 pr-1 mt-2 pl-2>
              <v-layout row wrap ma-0>
                <v-flex xs12 mt-2>
                  <p class="body-2 font-weight-medium mb-2">3.1 ตำแหน่ง</p>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    :block="$vuetify.breakpoint.width < 400"
                    rounded
                    :outlined="stationAreaBtn !== 'around'"
                    color="primary"
                    @click="stationAreaBtn = 'around'"
                  >
                    <v-icon left v-show="stationAreaBtn === 'around'">check_circle_outline</v-icon
                    >บริเวณสถานี
                  </v-btn>
                  <v-btn
                    :block="$vuetify.breakpoint.width < 400"
                    rounded
                    :outlined="stationAreaBtn !== 'between'"
                    color="primary"
                    :class="{
                      'ml-1': $vuetify.breakpoint.width >= 400,
                      'mt-2': $vuetify.breakpoint.width < 400
                    }"
                    @click="stationAreaBtn = 'between'"
                  >
                    <v-icon left v-show="stationAreaBtn === 'between'">check_circle_outline</v-icon
                    >ระหว่างสถานี
                  </v-btn>
                </v-flex>
                <v-flex md12 mt-2 v-show="stationAreaBtn === 'between'">
                  <p class="body-2 mb-1">
                    ข้อมูลสาย
                    <span class="remark">**</span>
                  </p>
                  <v-layout row wrap ma-0>
                    <v-flex xs12 sm5 pr-1 order-1>
                      <v-select
                        v-model="roadSelect"
                        :items="roadItems"
                        no-data-text="ไม่พบข้อมูล"
                        class="card-border"
                        item-text="name"
                        placeholder="เลือก"
                        flat
                        solo
                        hide-details
                        return-object
                        @change="onRoadChange"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 pl-1 order-4 order-sm-3 d-sm-flex align-sm-center>
                      <p class="body-2 mt-1 mt-sm-0 mb-sm-0 primary--text">{{ kmErrortext }}</p>
                    </v-flex>
                    <v-flex xs12 pr-1 order-2 order-sm-4>
                      <p v-show="roadSelectText !== ''" class="body-2 mt-1 mb-0 mb-sm-3">
                        {{ roadSelectText }}
                      </p>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex sm12 md4 mt-2 pl-md-2></v-flex>
                <v-flex xs12 mt-2>
                  <p class="body-2 mb-1">
                    สถานี
                    <span class="remark">**</span>
                  </p>
                  <!-- <v-flex sm12 md7> -->
                  <v-layout
                    height="50"
                    class="align-center"
                    :class="{ 'row wrap ma-0': $vuetify.breakpoint.width <= 450 }"
                  >
                    <v-flex
                      :class="{
                        xs12: $vuetify.breakpoint.width <= 450,
                        'xs4 pr-1': $vuetify.breakpoint.width > 450
                      }"
                    >
                      <v-autocomplete
                        v-model="telegraphFrom"
                        :items="telegraphFromItems"
                        class="card-border"
                        no-data-text="ไม่พบข้อมูล"
                        item-text="name"
                        item-value="id"
                        placeholder="เลือก"
                        v-on:change="changeLocation"
                        flat
                        solo
                        hide-details
                        :menu-props="{ value: telegraphFromMenu, closeOnContentClick: true }"
                        @click="telegraphFromMenu = true"
                        @blur="
                          e =>
                            autocompleteOnBlur(
                              'telegraphFrom',
                              telegraphFromItems[0],
                              'telegraphFromMenu',
                              e
                            )
                        "
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex
                      xs1
                      class="d-flex justify-center align-center"
                      :class="{ 'mt-2': $vuetify.breakpoint.width <= 450 }"
                    >
                      <p class="body-2 ma-0" v-show="stationAreaBtn == 'between'">ถึง</p>
                    </v-flex>
                    <v-flex
                      :class="{
                        'xs10 mt-2': $vuetify.breakpoint.width <= 450,
                        'xs4 pl-1': $vuetify.breakpoint.width > 450
                      }"
                    >
                      <v-autocomplete
                        v-show="stationAreaBtn == 'between'"
                        v-model="telegraphTo"
                        :items="telegraphToItems"
                        class="card-border"
                        no-data-text="ไม่พบข้อมูล"
                        item-text="name"
                        item-value="id"
                        placeholder="เลือก"
                        flat
                        solo
                        hide-details
                        :menu-props="{ value: telegraphToMenu, closeOnContentClick: true }"
                        @click="telegraphToMenu = true"
                        @blur="
                          e =>
                            autocompleteOnBlur(
                              'telegraphTo',
                              telegraphToItems[0],
                              'telegraphToMenu',
                              e
                            )
                        "
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <!-- </v-flex> -->
                </v-flex>
                <v-flex sm12 md12 mt-2 v-show="stationAreaBtn == 'between'">
                  <p class="body-2 mb-1">
                    กม
                  </p>
                  <v-layout row wrap ma-0>
                    <v-flex sm12 md2>
                      <v-text-field
                        hide-details
                        v-model="km"
                        class="card-border mt-2 mt-sm-0"
                        placeholder="กม.ที่"
                        clearable
                        my-auto
                        solo
                        flat
                        type="number"
                        step="0.001"
                        @blur="checkKmLimit"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex sm12 md4 mt-2 v-show="stationAreaBtn == 'between'">
                  <p class="body-2 mb-1">เสาโทรเลข</p>
                  <v-layout>
                    <v-flex pr-1>
                      <v-text-field
                        hide-details
                        v-model="telegraphNo"
                        class="card-border"
                        @keypress="onlyNumber($event)"
                        @paste.prevent
                        placeholder="1 - 20"
                        clearable
                        my-auto
                        solo
                        flat
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex
                      xs1
                      class="d-flex justify-center align-center"
                      :class="{ 'mt-2': $vuetify.breakpoint.width <= 450 }"
                    >
                      <p class="body-2 ma-0">ถึง</p>
                    </v-flex>
                    <v-flex px-1>
                      <v-select
                        v-model="telegraphNoSelect"
                        :items="telegraphNoItems"
                        no-data-text="ไม่พบข้อมูล"
                        class="card-border"
                        placeholder="-"
                        flat
                        solo
                        hide-details
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex sm12 md4 mt-2 pl-md-2 v-show="false">
                  <p class="body-2 mb-1">จำนวนเสา</p>
                  <v-text-field
                    hide-details
                    v-model="postAmount"
                    class="card-border"
                    @paste.prevent
                    @keypress="onlyNumber($event)"
                    placeholder="16 - 20"
                    clearable
                    my-auto
                    solo
                    flat
                  ></v-text-field>
                </v-flex>
                <v-flex sm12 layout wrap>
                  <v-flex xs12 sm4 mt-2 pr-sm-1>
                    <p class="body-2 ma-0">จังหวัด</p>
                    <v-select
                      v-model="provinceSelect"
                      :items="provinceItems"
                      item-text="name"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกจังหวัด"
                      class="card-border"
                      :readonly="
                        false && telegraphFrom != '' && telegraphFrom != 0 && provinceSelect !== ''
                      "
                      return-object
                      flat
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm4 mt-2 pl-sm-1 pr-sm-1>
                    <p class="body-2 ma-0">อำเภอ</p>
                    <v-select
                      v-model="amphoeSelect"
                      :items="amphoeItems"
                      item-text="name"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกอำเภอ"
                      class="card-border"
                      :readonly="
                        false && telegraphFrom != '' && telegraphFrom != 0 && amphoeSelect !== ''
                      "
                      return-object
                      flat
                      solo
                      hide-details
                    />
                  </v-flex>
                  <v-flex xs12 sm4 mt-2 pl-sm-1>
                    <p class="body-2 ma-0">ตำบล</p>
                    <v-select
                      v-model="tambonSelect"
                      :items="tambonItems"
                      item-text="name"
                      no-data-text="ไม่พบข้อมูล"
                      label="เลือกตำบล"
                      class="card-border"
                      :readonly="
                        false && telegraphFrom != '' && telegraphFrom != 0 && tambonSelect !== ''
                      "
                      return-object
                      flat
                      solo
                      hide-details
                    />
                  </v-flex>
                </v-flex>
                <v-flex xs12 mt-2>
                  <p class="body-2 ma-0">กรุณาเลื่อนแผนที่ไปยังจุดเกิดเหตุ</p>
                  <div class="map">
                    <longdo-map :mapOptions="mapOptions" @onload="initMap" />
                  </div>
                </v-flex>
                <v-flex xs12 mt-7>
                  <p class="body-2 font-weight-medium mb-2">3.2 ลักษณะบริเวณที่เกิดเหตุ</p>
                </v-flex>
                <v-flex xs12 sm10 row wrap ma-0 class="d-flex flex-row">
                  <v-flex xs12>
                    <v-radio-group v-model="surroundSelect" class="ma-0" hide-details>
                      <v-radio
                        v-for="item in surroundItems"
                        :key="item.id"
                        color="primary"
                        :label="item.name"
                        :value="item"
                        :class="{
                          'radio-height-40': $vuetify.breakpoint.width > 800,
                          'input-align-normal': $vuetify.breakpoint.width <= 800,
                          'pb-12': item.id == 2 && $vuetify.breakpoint.xsOnly
                        }"
                      >
                        <template #label v-if="item.needDescription">
                          <v-row>
                            <v-col cols="2" class="py-0">อื่นๆ</v-col>
                            <v-col class="py-0">
                              <v-text-field
                                v-model="otherSurroundDescription"
                                hide-details
                                clearable
                                my-auto
                                solo
                                flat
                                placeholder="ระบุ"
                                class="card-border max-width-200 text-field-as-lebel ml-2"
                                :dense="true"
                              />
                            </v-col>
                          </v-row>
                        </template>

                        <template #label v-else>
                          <div
                            class="d-flex"
                            :class="{
                              'flex-column': $vuetify.breakpoint.width <= 800,
                              'align-start': $vuetify.breakpoint.width > 800
                            }"
                          >
                            {{ item.name }}
                            <v-select
                              v-if="item.id == 2"
                              v-model="crossingSelect"
                              :items="crossingItems"
                              no-data-text="ไม่พบข้อมูล"
                              label="เลือก"
                              class="card-border max-width-200 select-as-lebel"
                              :class="{
                                'mt-2': $vuetify.breakpoint.width <= 800,
                                'ml-2': $vuetify.breakpoint.width > 800
                              }"
                              item-text="name"
                              item-value="id"
                              flat
                              solo
                              hide-details
                              :disabled="!surroundSelect || surroundSelect.id != 2"
                              @change="railroadCrossingSelect = ''"
                            ></v-select>
                            <v-select
                              v-if="item.id == 2"
                              v-model="railroadCrossingSelect"
                              :items="railroadCrossingItems"
                              no-data-text="ไม่พบข้อมูล"
                              label="เลือก"
                              class="card-border max-width-200 select-as-lebel"
                              :class="{
                                'mt-2': $vuetify.breakpoint.width <= 800,
                                'ml-2': $vuetify.breakpoint.width > 800
                              }"
                              item-text="name"
                              item-value="id"
                              flat
                              solo
                              hide-details
                              v-show="crossingSelect == 6 && railroadCrossingItems.length > 0"
                            ></v-select>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-flex>
                <v-flex xs12 mt-7>
                  <p class="body-2 font-weight-medium mb-2 mt-8">3.3 สภาพดินฟ้าอากาศ</p>
                </v-flex>
                <v-flex xs12 sm10 md7 row wrap ma-0 class="d-flex flex-row">
                  <v-radio-group v-model="weather" class="ma-0" hide-details>
                    <v-row>
                      <v-col class="col-12 col-md-6" v-for="item in weatherItems" :key="item.id">
                        <v-radio
                          v-if="item.needDescription === true"
                          :key="`weather-radio-${item.id}`"
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        >
                          <template #label>
                            <v-row>
                              <v-col cols="2" class="py-0">
                                {{ item.name }}
                              </v-col>
                              <v-col class="py-0">
                                <v-text-field
                                  v-model="otherWeatherDescription"
                                  hide-details
                                  clearable
                                  my-auto
                                  solo
                                  flat
                                  placeholder="ระบุ"
                                  class="card-border max-width-200 text-field-as-lebel ml-2"
                                />
                              </v-col>
                            </v-row>
                          </template>
                        </v-radio>

                        <v-radio
                          v-else
                          :key="`weather-radio-${item.id}`"
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-flex>

                <v-flex xs12 mt-7>
                  <p class="body-2 font-weight-medium mb-2 mt-8">3.4 กลางวัน/กลางคืน</p>
                </v-flex>
                <v-flex xs12 sm10 md7 row wrap ma-0 class="d-flex flex-row">
                  <v-radio-group v-model="light" class="ma-0" hide-details style="width:100%">
                    <v-row>
                      <v-flex class="col-12 col-md-6" v-for="item in lightItems" :key="item.id">
                        <v-radio
                          :key="`light-radio-${item.id}`"
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        ></v-radio>
                      </v-flex>
                    </v-row>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-layout>
        <!-- 4 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">4</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                ลักษณะการเกิดอุบัติเหตุ โดยย่อ
              </p>
            </div>
          </v-flex>
          <v-flex xs12 sm10 md7 class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0 pl-2>
              <template v-for="column in 2">
                <v-flex :key="`accident-character-radio-contianer-${column}`" xs12 sm6>
                  <v-radio-group v-model="accidentCharacter" class="ma-0" hide-details>
                    <template
                      v-for="(item, index) in accidentCharacterItemsSplitColumns[column - 1]"
                    >
                      <template>
                        <v-radio
                          :key="`accident-character-radio-${index}`"
                          v-if="item.needDescription === true"
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        >
                          <template #label>
                            <v-row>
                              <v-col cols="2" class="py-0">
                                อื่นๆ
                              </v-col>
                              <v-col class="py-0">
                                <v-text-field
                                  v-model="otherAccidentCharacterDescription"
                                  hide-details
                                  clearable
                                  my-auto
                                  solo
                                  flat
                                  placeholder="ระบุ"
                                  class="card-border max-width-200 text-field-as-lebel ml-2"
                                />
                              </v-col>
                            </v-row>
                          </template>
                        </v-radio>
                        <v-radio
                          :key="`accident-character-radio-${index}`"
                          v-else
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        ></v-radio>
                      </template>
                    </template>
                  </v-radio-group>
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 5 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">5</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">คู่กรณี</p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0>
              <v-flex xs12>
                <VehicleFormDialog
                  ref="vehicleFormDialog"
                  title="ผู้ใช้ทางและยานพาหนะ"
                  :isAddTrain="true"
                  @getVehicleLists="updateVehicle"
                  :provinceListItem="provinceItems"
                  :vehicleListItem="vehicleItems"
                  :vehicleBrandListItem="vehicleBrandItems"
                  :sexListItem="sexItems"
                  notVehicleId="6"
                />
              </v-flex>
              <v-flex xs12 sm8 mb-8 v-for="item in opsideItems" :key="item.id">
                <v-checkbox
                  v-model="opsideSelect"
                  :value="item"
                  class="input-align-normal full-width"
                  color="primary"
                  hide-details
                >
                  <template #label>
                    <v-layout>
                      <v-flex>
                        <p class="mb-2">{{ item.name }}</p>
                        <div>
                          <v-text-field
                            :ref="`opside-${item.id}`"
                            v-model="item.desc"
                            hide-details
                            my-auto
                            solo
                            flat
                            class="card-border text-field-as-lebel"
                            @click.capture.stop="toggleOpside(item)"
                            @change="checkOpside(item)"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 6 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">6</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">ความรุนแรง</p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12>
            <div class="topic-line hidden"></div>
            <v-flex xs12 sm9 md6 pr-1 pl-2 mt-2 class="form-4">
              <v-row no-gutters>
                <v-col class="damage-title-column"></v-col>
                <v-col>
                  <p class="body-2 font-weight-medium mb-1 ml-2">ชาย (คน)</p>
                </v-col>
                <v-col>
                  <p class="body-2 font-weight-medium mb-1 ml-2">หญิง (คน)</p>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="d-flex justify-start align-center damage-title-column">
                  <p class="body-2 font-weight-medium ma-0">ผู้เสียชีวิต</p>
                </v-col>
                <v-col class="pa-1">
                  <v-text-field
                    v-model="dead.male"
                    hide-details
                    my-auto
                    solo
                    flat
                    class="card-border"
                    @keypress="onlyNumber($event)"
                  />
                </v-col>
                <v-col class="pa-1">
                  <v-text-field
                    v-model="dead.female"
                    hide-details
                    my-auto
                    solo
                    flat
                    class="card-border"
                    @keypress="onlyNumber($event)"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="d-flex justify-start align-center damage-title-column">
                  <p class="body-2 font-weight-medium ma-0">ผู้บาดเจ็บสาหัส</p>
                </v-col>
                <v-col class="pa-1">
                  <v-text-field
                    v-model="severed.male"
                    hide-details
                    my-auto
                    solo
                    flat
                    class="card-border"
                    @keypress="onlyNumber($event)"
                  />
                </v-col>
                <v-col class="pa-1">
                  <v-text-field
                    v-model="severed.female"
                    hide-details
                    my-auto
                    solo
                    flat
                    class="card-border"
                    @keypress="onlyNumber($event)"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="d-flex justify-start align-center damage-title-column">
                  <p class="body-2 font-weight-medium ma-0">ผู้บาดเจ็บ</p>
                </v-col>
                <v-col class="pa-1">
                  <v-text-field
                    v-model="injury.male"
                    hide-details
                    my-auto
                    solo
                    flat
                    class="card-border"
                    @keypress="onlyNumber($event)"
                  />
                </v-col>
                <v-col class="pa-1">
                  <v-text-field
                    v-model="injury.female"
                    hide-details
                    my-auto
                    solo
                    flat
                    class="card-border"
                    @keypress="onlyNumber($event)"
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-flex>
        </v-layout>
        <!-- 7 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">7</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                ทรัพย์สินของการรถไฟที่เสียหาย
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0 pl-2>
              <v-flex xs12 pr-1 mb-8 v-for="item in trainDamageList" :key="item.id">
                <v-checkbox
                  v-model="trainDamageSelect"
                  :value="item"
                  class="input-align-normal"
                  color="primary"
                  label
                  hide-details
                >
                  <template #label>
                    <v-layout row wrap ma-0>
                      <v-flex xs12 sm6 pr-sm-1 v-if="item.isRequiredQuantity">
                        <p class="mb-2">{{ item.name }}</p>
                        <div>
                          <v-text-field
                            :ref="`damage-${item.id}`"
                            v-model="item.quantity"
                            hide-details
                            my-auto
                            solo
                            flat
                            class="card-border text-field-as-lebel"
                            @click.capture.stop="toggleDamage(item)"
                            @change="checkDamage(item)"
                          />
                        </div>
                      </v-flex>
                      <v-flex xs12 sm6 pl-sm-1 v-if="item.isRequiredQuantity">
                        <p class="mb-2">มูลค่าโดยประมาณ (บาท)</p>
                        <div @click.stop.prevent>
                          <v-text-field
                            v-model="item.cost"
                            hide-details
                            clearable
                            my-auto
                            solo
                            flat
                            class="card-border text-field-as-lebel"
                            @click.capture.stop="toggleDamage(item)"
                            @change="checkDamage(item)"
                            @keypress="onlyNumber($event)"
                            type="number"
                            min="0"
                          />
                        </div>
                      </v-flex>

                      <v-flex xs12 sm12 pr-sm-1 v-else>
                        <p class="mb-2">{{ item.name }} : มูลค่าโดยประมาณ (บาท)</p>
                        <div>
                          <v-text-field
                            :ref="`damage-${item.id}`"
                            v-model="item.cost"
                            hide-details
                            clearable
                            my-auto
                            solo
                            flat
                            class="card-border text-field-as-lebel"
                            @click.capture.stop="toggleDamage(item)"
                            @keypress="onlyNumber($event)"
                            @change="checkDamage(item)"
                            type="number"
                            min="0"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 8 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">8</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2">การดำเนินการ / ขอความช่วยเหลือ</p>
            </div>
          </v-flex>
          <v-flex sm12 md10 class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0 pl-2>
              <v-flex
                mb-8
                v-for="item in helpingItems"
                :key="item.id"
                :class="{
                  xs12: $vuetify.breakpoint.width <= 850,
                  xs6: $vuetify.breakpoint.width > 850
                }"
                pr-1
              >
                <v-checkbox
                  v-model="helpingSelect"
                  :value="item"
                  class="input-align-normal"
                  color="primary"
                  hide-details
                >
                  <template #label>
                    <v-layout>
                      <v-flex pr-1>
                        <p class="mb-2">{{ item.name }}</p>
                        <div>
                          <v-text-field
                            :ref="`further-${item.id}`"
                            v-model="item.desc"
                            hide-details
                            clearable
                            my-auto
                            solo
                            flat
                            @click.capture.stop="toggleFurther(item)"
                            @change="checkHelping(item)"
                            class="card-border text-field-as-lebel"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 9 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">9</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2">
                ข้อมูลสารเคมี (ในกรณีสารเคมีที่บรรทุกหกรั่วไหล)
              </p>
            </div>
          </v-flex>
          <v-flex sm12 md8 class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0>
              <v-flex xs12 pl-2 pt-4>
                <p class="body-2 mb-1">สารเคมี</p>
                <v-select
                  v-model="chemicalTypeSelect"
                  :items="chemicalTypeItems"
                  item-text="name"
                  item-value="id"
                  no-data-text="ไม่พบข้อมูล"
                  label="เลือกสารเคมี"
                  class="card-border"
                  flat
                  solo
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 pl-2 pt-4>
                <p class="body-2 mb-1">ปริมาณสารเคมี</p>
                <v-select
                  v-model="chemicalAmountSelect"
                  :items="chemicalAmountItems"
                  no-data-text="ไม่พบข้อมูล"
                  class="card-border"
                  item-text="name"
                  item-value="id"
                  placeholder="เลือกทปริมาณ"
                  flat
                  solo
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 pl-2 pt-4>
                <p class="body-2 mb-1">ช่วงเวลาที่สารเคมีหก</p>
                <v-select
                  v-model="chemicalTimeSelect"
                  :items="chemicalTimeItems"
                  no-data-text="ไม่พบข้อมูล"
                  class="card-border"
                  item-text="name"
                  item-value="id"
                  placeholder="เลือกเวลา"
                  flat
                  solo
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 pl-2 pt-4>
                <p class="body-2 mb-1">ทิศทางลม</p>
                <v-select
                  v-model="windDirectionSelect"
                  :items="windDirectionItems"
                  no-data-text="ไม่พบข้อมูล"
                  class="card-border"
                  item-text="name"
                  item-value="id"
                  placeholder="เลือกทิศทางลม"
                  flat
                  solo
                  hide-details
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 10 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">10</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2">
                รายละเอียดเพิ่มเติม
                <span v-show="trainSelect != null && trainSelect.id == 0" class="remark">**</span>
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-flex xs12 pl-2 pt-4>
              <v-textarea
                v-model="description"
                hide-hint
                :auto-grow="true"
                clearable
                my-auto
                solo
                flat
                class="card-border"
              ></v-textarea>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 mt-10 ml-10 class="updated-user">
        <v-row class="ma-0" :class="{ 'mb-3': $vuetify.breakpoint.width <= 630 }">
          <v-col :cols="$vuetify.breakpoint.width > 630 ? '5' : '12'" class="text-title pa-0 py-1">
            <p class="body-2 font-weight-bold mb-0">ผู้บันทึก</p>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.width > 630 ? '7' : '12'"
            class="pa-0 py-1"
            :class="{ 'pl-2': $vuetify.breakpoint.width <= 630 }"
          >
            <p class="body-2 font-weight-regular mb-0">{{ username }}</p>
          </v-col>
        </v-row>
        <v-row class="ma-0" :class="{ 'mb-3': $vuetify.breakpoint.width <= 630 }">
          <v-col :cols="$vuetify.breakpoint.width > 630 ? '5' : '12'" class="text-title pa-0 py-1">
            <p class="body-2 font-weight-bold mb-0">หน่วยงาน</p>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.width > 630 ? '7' : '12'"
            class="pa-0 py-1"
            :class="{ 'pl-2': $vuetify.breakpoint.width <= 630 }"
          >
            <p class="body-2 font-weight-regular mb-0" v-if="department">{{ department }}</p>
            <p class="body-2 font-weight-regular mb-0" v-else>-</p>
          </v-col>
        </v-row>
        <v-row class="ma-0" :class="{ 'mb-3': $vuetify.breakpoint.width <= 630 }">
          <v-col :cols="$vuetify.breakpoint.width > 630 ? '5' : '12'" class="text-title pa-0 py-1">
            <p class="body-2 font-weight-bold mb-0">E-mail</p>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.width > 630 ? '7' : '12'"
            class="pa-0 py-1"
            :class="{ 'pl-2': $vuetify.breakpoint.width <= 630 }"
          >
            <p class="body-2 font-weight-regular mb-0" v-if="email">{{ email }}</p>
            <p class="body-2 font-weight-regular mb-0" v-else>-</p>
          </v-col>
        </v-row>
        <v-row class="ma-0" :class="{ 'mb-3': $vuetify.breakpoint.width <= 630 }">
          <v-col :cols="$vuetify.breakpoint.width > 630 ? '5' : '12'" class="text-title pa-0 py-1">
            <p class="body-2 font-weight-bold mb-0">วันที่บันทึกล่าสุด</p>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.width > 630 ? '7' : '12'"
            class="pa-0 py-1"
            :class="{ 'pl-2': $vuetify.breakpoint.width <= 630 }"
          >
            <p class="body-2 font-weight-regular mb-0">{{ currentDateTime }}</p>
          </v-col>
        </v-row>
      </v-flex>
      <v-flex
        class="d-flex flex-column flex-sm-row align-end mt-10 mt-sm-0"
        :class="{ 'height-200': $vuetify.breakpoint.smAndUp }"
      >
        <v-spacer></v-spacer>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          rounded
          outlined
          width="120"
          color="primary"
          class="mt-2"
          @click="goBacktoReport"
          >ยกเลิก</v-btn
        >
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          rounded
          width="120"
          color="primary"
          class="mt-2 ml-2"
          @click="validateForm"
          >บันทึก</v-btn
        >
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex v-show="false">
        <MapMarker ref="map-marker" />
      </v-flex>
      <v-flex>
        <AlertDialog
          v-model="alertDialog"
          :status="isServiceSuccess ? 'success' : 'error'"
          :cancel-btn="cancelBtn"
          :hide-icon="hideIcon"
          v-on:ok-btn-click="alertDialogOkClicked"
          v-on:cancel-btn-click="alertDialogCancelClicked"
          ><span style="white-space: pre;"> {{ alertDialogMessage }}</span></AlertDialog
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DatePicker from '../global/DatePicker.vue';
import TimePicker from '../global/TimePicker.vue';
import VehicleFormDialog from '../global/VehicleFormDialog.vue';
import AlertDialog from '../global/AlertDialog';
import MapMarker from '../MapMarker.vue';

const qs = require('qs');
const turf = require('@turf/helpers');
turf.length = require('@turf/length').default;
turf.along = require('@turf/along').default;

export default {
  name: 'Default-Train',
  components: {
    DatePicker,
    TimePicker,
    VehicleFormDialog,
    MapMarker,
    AlertDialog
  },
  props: {
    accident: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    username: '',
    department: '',
    email: '',
    map: {},
    mapOptions: {
      ui: false,
      zoomRange: {
        max: 18,
        min: 3
      }
    },
    reportDate: '',
    reportProvinceSelect: '',
    reportProvinceItems: [],
    // 1
    date: '',
    time: '',
    // 2
    trainSelect: null,
    trainItems: [],
    // 3.1
    stationAreaBtn: 'around',
    stationFrom: '',
    stationFromItems: [],
    stationTo: '',
    stationToItems: [],
    roadSelect: null,
    roadItems: [],
    km: '',
    postAmount: '',
    telegraphNo: '',
    telegraphNoSelect: '',
    telegraphFrom: '',
    telegraphFromItems: [],
    telegraphTo: '',
    telegraphToItems: [],
    provinceSelect: '',
    provinceTempName: '',
    provinceItems: [],
    amphoeSelect: '',
    amphoeTempId: '',
    amphoeTempName: '',
    amphoeItems: [],
    amphoeAllItems: [],
    tambonSelect: '',
    tambonTempId: '',
    tambonTempName: '',
    tambonItems: [],
    tambonAllItems: [],
    // 3.2
    surroundSelect: '',
    surroundItems: [],
    otherSurroundDescription: '',
    crossingSelect: '',
    crossingItems: [],
    railroadCrossingSelect: '',
    railroadCrossingItems: [],
    // 3.3
    weather: '',
    weatherItems: [],
    // 3.4
    light: '',
    lightItems: [],
    otherWeatherDescription: '',
    // 4
    accidentCharacter: '',
    accidentCharacterItems: [],
    otherAccidentCharacterDescription: '',
    // 5
    opsideSelect: [],
    opsideItems: [],
    // 6
    dead: {
      male: '',
      female: ''
    },
    injury: {
      male: '',
      female: ''
    },
    severed: {
      male: '',
      female: ''
    },
    // 7
    trainDamageSelect: [],
    trainDamageList: [],
    // 8
    helpingSelect: [],
    helpingItems: [],
    helpingStation: '',
    helpingStationItems: [],
    // 9
    chemicalTypeSelect: '',
    chemicalTypeItems: [],
    chemicalAmountSelect: '',
    chemicalAmountItems: [],
    chemicalTimeSelect: '',
    chemicalTimeItems: [],
    windDirectionSelect: '',
    windDirectionItems: [],
    // 10
    description: '',
    vehicle: [],
    vehicleItems: [],
    vehicleBrandItems: [],
    sexItems: [],
    // Alert Dialog
    alertDialog: false,
    isServiceSuccess: false,
    cancelBtn: false,
    hideIcon: false,
    alertDialogMessage: '',
    trainSelectMenu: false,
    telegraphFromMenu: false,
    telegraphToMenu: false,
    trainSelectInput: '',
    defaultData: {},
    trainLine: {
      start: null,
      end: null,
      geom: null
    }
  }),
  created() {
    this.getTrainOption();
  },
  mounted() {},
  methods: {
    init() {
      if (this.accident !== '' && this.accident !== null && this.accident !== undefined) {
        this.username = localStorage.getItem('fullname') || '-';
        this.department = localStorage.getItem('department');
        this.email = localStorage.getItem('email') || '-';
        // this.getAccidentDetail();
        const scope = this;
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/form/get/accident/${scope.accident}`;
        this.axios
          .get(url)
          .then(response => {
            if (response.status === 200 && response.data.data) {
              this.mapData(response.data.data);
              this.getVehicleTypeList();
              this.getVehicleBrandList();
              this.getSexList();
              this.getStationLists();
              this.getProvinceLists();
              this.getChemicalLists();
              this.getChemicalQuantityLists();
              this.getChemicalTimeLists();
              this.getChemicalWindLists();
              this.getOpsideLists();
              this.getFurtherLists();
              this.getRailwayLineList();
              this.getRailwayRoute();
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        this.username = localStorage.getItem('fullname') || '-';
        this.department = localStorage.getItem('department');
        this.email = localStorage.getItem('email') || '-';
        this.getVehicleTypeList();
        this.getVehicleBrandList();
        this.getSexList();
        this.getStationLists();
        this.getProvinceLists();
        this.getChemicalLists();
        this.getChemicalQuantityLists();
        this.getChemicalTimeLists();
        this.getChemicalWindLists();
        this.getOpsideLists();
        this.getFurtherLists();
        this.getRailwayLineList();
        this.getRailwayRoute();
        this.reportDate = this.utils.getLocalDate();
        this.$refs.reportDate.setDefaultData(this.reportDate);
      }
    },
    initMap(map) {
      this.map = map;
      window.mapdebug = this.map;
      this.map.zoom(18);
      this.map.location({ lat: 13.7589, lon: 100.5076 });
      window.lastLocation = this.map.location();
      this.map.Ui.BottomLeft.parentElement.append(this.$refs['map-marker'].$el);

      const scope = this;
      this.map.Event.bind('location', function() {
        lastLocation = mapdebug.location();
      });
      this.map.Event.bind('zoom', function() {
        if (lastLocation) {
          mapdebug.location(lastLocation, false);
        }
      });
      this.getMapLayer();
      this.init();
    },
    onRoadChange() {
      this.km = '';
      this.telegraphFrom = '';
      this.telegraphTo = '';
      this.telegraphNo = '';
      this.telegraphNoSelect = '';
      this.provinceSelect = '';
      this.amphoeSelect = '';
      this.tambonSelect = '';
      this.getStationLists(false);
    },
    validateForm() {
      const errtext = [];
      if (!this.date) errtext.push('- วันที่');
      if (!this.time) errtext.push('- เวลา');
      if (!this.trainSelect) errtext.push('- ขบวนรถ');
      if (this.stationAreaBtn === 'between' && !this.roadSelect) errtext.push('- ข้อมูลสาย');
      if (!this.telegraphFrom) errtext.push('- สถานี');
      if (errtext.length > 0)
        this.setupAlertDialog(
          true,
          false,
          'validateErr',
          false,
          `กรุณาระบุข้อมูลต่อไปนี้\n${errtext.join('\n')}`
        );
      else this.setupAlertDialog(true, true, 'saveAccident', true, 'ยืนยันการบันทึกข้อมูล ?');
    },
    goBacktoReport() {
      this.$router.push({ name: 'report' });
    },
    getMapLayer() {
      const self = this;
      const jsonpAdapter = require('axios-jsonp');

      const baseUrl = 'https://api.nostramap.com/Service/V2/Map/GetPermission?key=';
      const key = `${process.env.VUE_APP_NOSTRA_MAP_KEY}`;

      this.axios({
        url: baseUrl + key,
        adapter: jsonpAdapter
      }).then(response => {
        if (response.status === 200) {
          self.setBaseMap(response.data.results);
        }
      });
    },
    setBaseMap(layer) {
      const base = layer.filter(x => x.serviceID === '1');
      if (base.length === 1) {
        const nostraSteet = new window.longdo.Layer(false, {
          type: window.longdo.LayerType.ArcGIS_REST,
          url: base[0].serviceURL_L,
          key: base[0].serviceToken_L
        });

        this.map.Layers.setBase(nostraSteet);
      }
    },
    getTrainOption() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/train_option`;
      const scope = this;
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            const { data } = response.data;
            scope.surroundItems = data.surround_character.filter(member => {
              if (member.name === 'อื่นๆ (ระบุ)') member.needDescription = true;
              return member.form_level == 1;
            });
            const crosstrain = {
              id: 2,
              name: 'จุดตัดถนนกับทางรถไฟ'
            };
            scope.surroundItems.splice(2, 0, crosstrain);
            scope.crossingItems = data.surround_character.filter(member => {
              return member.form_level == 2;
            });
            scope.railroadCrossingItems = data.surround_character.filter(member => {
              return member.form_level == 3;
            });
            scope.weatherItems = data.surround_weather;
            scope.weatherItems.forEach(element => {
              if (element.name === 'อื่นๆ') element.needDescription = true;
            });
            scope.accidentCharacterItems = data.accident_pattern;
            scope.accidentCharacterItems.forEach(element => {
              if (element.name === 'อื่น ๆ') element.needDescription = true;
            });
            scope.lightItems = data.surround_light;
            scope.trainDamageList = data.damage_list;
            scope.trainDamageList.forEach(element => {
              if (element.name !== 'เครื่องกั้นรถไฟ') element.isRequiredQuantity = true;
            });
          }
        })
        .catch(function(error) {
          const { response } = error;
          if (response.status === 401) {
            console.log('unauthorized');
            scope.$router.push({ name: 'unauthorized' });
          }
          console.log(error);
        });
    },
    getDateTimeString(dt) {
      const datetime = `${dt.getFullYear()}-${`0${dt.getMonth() + 1}`.substr(
        -2
      )}-${`0${dt.getDate()}`.substr(-2)}`;

      return datetime;
    },
    getAccidentDetail() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/form/get/accident/${scope.accident}`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            this.mapData(response.data.data);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    setDefaultObject(Allitem, setitem, field) {
      const item = Allitem.filter(member => {
        return member.id === this.defaultData[field];
      });
      this.defaultData[field] = null;
      this[setitem] = item[0];
    },
    mapData(data) {
      this.defaultData = data;
      const splitReportDate = data.report_date ? data.report_date.split('-') : [];
      if (splitReportDate.length === 3) {
        this.$refs.reportDate.setDefaultData(
          `${splitReportDate[2]}-${splitReportDate[1]}-${splitReportDate[0]}`
        );
      }

      const province = data.province_report
        ? this.provinceItems.filter(x => x.id.toString() === data.province_report.toString())
        : [];
      this.reportProvinceSelect = province.length === 1 ? province[0] : '';

      // no.1
      const splitAccidentDate = data.accident_date ? data.accident_date.split('-') : [];
      if (splitAccidentDate.length === 3) {
        this.$refs.accidentDate.setDefaultData(
          `${splitAccidentDate[2]}-${splitAccidentDate[1]}-${splitAccidentDate[0]}`
        );
      }
      this.$refs.accidentTime.setDefaultData(data.accident_time);

      // no.3 Do in Call Back From Service
      if (data.km || data.pillar || data.pillar_to || data.station_to) {
        // or roadSelect
        this.stationAreaBtn = 'between';
      }
      this.km = data.km;
      this.telegraphNo = data.pillar || ''; // pillar and pillar_from has same value
      this.telegraphNoSelect = data.pillar_to || '';
      this.postAmount = data.pillar_amount || '';

      if (data.latitude && data.longitude) {
        this.map.location({ lat: data.latitude, lon: data.longitude });
      }

      if (data.crash_code) {
        const surround = this.surroundItems.filter(
          x => x.id.toString() === data.crash_code.toString()
        );
        if (surround.length) {
          if (surround[0].needDescription) {
            this.otherSurroundDescription = data.crash_name;
          }
          this.surroundSelect = surround[0];
        } else {
          this.surroundSelect = this.surroundItems[2];
          const check = this.crossingItems.find(member => member.id === data.crash_code);
          if (check) {
            this.crossingSelect = data.crash_code;
          } else {
            this.crossingSelect = this.crossingItems.find(
              member => member.name === 'เครื่องกั้น'
            ).id; // hard code
            this.railroadCrossingSelect = data.crash_code;
          }
        }
      }

      if (data.weather_code) {
        const weather = this.weatherItems.filter(
          x => x.id.toString() === data.weather_code.toString()
        );
        if (weather.length === 1) {
          if (weather[0].needDescription) {
            this.otherWeatherDescription = data.weather_name;
          }
          this.weather = weather[0];
        }
      }

      if (data.light_code) {
        const light = this.lightItems.filter(x => x.id.toString() === data.light_code.toString());
        this.light = light.length === 1 ? light[0] : '';
      }

      // no.2 Do in Call Back From Service

      // no.6
      this.dead.male = data.dead_male || '';
      this.dead.female = data.dead_female || '';
      this.injury.male = data.noneserious_injury_male || '';
      this.injury.female = data.noneserious_injury_female || '';
      this.severed.male = data.serious_injury_male || '';
      this.severed.female = data.serious_injury_female || '';

      // no.4
      if (data.pattern_code) {
        const pattern = this.accidentCharacterItems.filter(
          x => x.id.toString() === data.pattern_code.toString()
        );
        if (pattern.length === 1) {
          if (pattern[0].needDescription) {
            this.otherAccidentCharacterDescription = data.pattern_name;
          }
          this.accidentCharacter = pattern[0];
        }
      }

      // no.5
      for (let index = 0; index < data.vehicle.length; index++) {
        const element = data.vehicle[index];
        if (element.plate) {
          const carplate = element.plate.split('-');
          data.vehicle[index].plate1 = carplate[0];
          data.vehicle[index].plate2 = carplate[1];
        }
      }
      this.$refs.vehicleFormDialog.setDefaultData(data.vehicle);

      // Do in Call Back opsideItems

      // no.7
      if (data.damage_list) {
        data.damage_list.forEach(item => {
          const damage = this.trainDamageList.filter(x => x.id.toString() === item.id.toString());
          if (damage.length === 1) {
            damage[0].quantity = item.quantity;
            damage[0].cost = item.cost;
            this.trainDamageSelect.push(damage[0]);
          }
        });
      }

      // no.8 Do in Call Back From Service

      // no.9
      this.chemicalTypeSelect = data.chemical_code || '';
      this.chemicalAmountSelect = data.chemical_quantity || '';
      this.chemicalTimeSelect = data.chemical_time || '';
      this.windDirectionSelect = data.chemical_wind || '';

      // no.10
      this.description = data.summary;
    },
    getRailwayLineList() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/railway_line`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.trainItems = response.data.data;
            scope.trainItems[0].id = 'ขบวนอื่นๆ';
            if (scope.defaultData.train_no) {
              scope.setDefaultObject(scope.trainItems, 'trainSelect', 'train_no');
            }
          }
        })
        .catch(function(error) {
          scope.trainItems = [];
          console.log(error);
        });
    },
    getRailwayRoute() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/railway_route`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.roadItems = response.data.data;
            if (scope.defaultData.railway_code) {
              scope.setDefaultObject(scope.roadItems, 'roadSelect', 'railway_code');
            }
          }
        })
        .catch(function(error) {
          scope.roadItems = [];
          console.log(error);
        });
    },
    getVehicleTypeList() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/railway_vehicle_type`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.vehicleItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.vehicleItems = [];
          console.log(error);
        });
    },
    getVehicleBrandList() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/vehicle_brand`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.vehicleBrandItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.vehicleBrandItems = [];
          console.log(error);
        });
    },
    getSexList() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/casualty_sex`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.sexItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.sexItems = [];
          console.log(error);
        });
    },
    getStationLists(usedefault = true) {
      const scope = this;
      let url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/railway_station`;
      if (this.roadSelect != null && this.roadSelect.id != null) {
        url += `/${this.roadSelect.id}`;
      }

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.telegraphFromItems = response.data.data;
            scope.telegraphFrom = '';
            scope.telegraphTo = '';
            if (scope.telegraphFromItems.length > 0)
              scope.telegraphFromItems.unshift({ id: 0, name: 'ไม่ได้เลือก' });
            if (scope.defaultData.station && usedefault) {
              scope.telegraphFrom = scope.defaultData.station;
              scope.changeLocation(scope.defaultData.station);
              scope.defaultData.station = null;
            }
          }
        })
        .catch(function(error) {
          scope.telegraphFromItems = [];
          console.error(error);
        });
    },
    getBetweenStationLists() {
      if (this.telegraphFrom === '') return;
      if (this.stationAreaBtn != 'between') return;

      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/between_railway_station/${this.telegraphFrom}`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.telegraphTo = '';
            scope.telegraphToItems = response.data.data;
            if (scope.defaultData.station_to) {
              scope.telegraphTo = scope.defaultData.station_to;
              scope.defaultData.station_to = null;
            }
          }
        })
        .catch(function(error) {
          scope.telegraphToItems = [];
          console.log(error);
        });
    },
    getTelegraphBetweenLocation() {
      if (this.telegraphFrom === '') return;
      if (this.telegraphTo === '') return;
      if (!this.telegraphNo) return;
      if (!this.telegraphNoSelect || this.telegraphNoSelect == '-')
        this.telegraphNoSelect = this.telegraphNo;

      const number = Number(this.postAmount);
      if (!isNaN(number) && number != 0) {
        this.postAmount = number;
      } else {
        this.postAmount = 16;
      }

      const _telegraphTo = this.telegraphToItems.filter(
        x => x.id.toString() === this.telegraphTo.toString
      );
      const telegraphToLength = _telegraphTo.length === 1 ? _telegraphTo[0].length : 1;

      let point =
        (Number(this.telegraphNo) + Number(this.telegraphNoSelect)) / (2 * this.postAmount);
      point *= telegraphToLength; // this.telegraphTo.length;

      if (this.trainLine.start == this.telegraphFrom && this.trainLine.end == this.telegraphTo) {
        const line = turf.lineString(this.trainLine.geom);
        const length = turf.length(line);
        const location = turf.along(line, length * point);
        if (location) {
          mapdebug.location({
            lat: location.geometry.coordinates[1],
            lon: location.geometry.coordinates[0]
          });
        }
        return;
      }

      const scope = this;
      let url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/between_railway_station_location?`;
      url += `&start_station=${this.telegraphFrom}`;
      url += `&end_station=${this.telegraphTo}`;
      url += `&point=${point}`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data && response.data.data.coordinates) {
            const { coordinates } = response.data.data;
            scope.trainLine = {
              start: scope.telegraphFrom,
              end: scope.telegraphTo,
              geom: coordinates
            };
            const line = turf.lineString(coordinates);
            const length = turf.length(line);
            const location = turf.along(line, length * point);
            if (location) {
              mapdebug.location({
                lat: location.geometry.coordinates[1],
                lon: location.geometry.coordinates[0]
              });
            }
          }
        })
        .catch(function(error) {
          scope.telegraphToItems = [];
          console.log(error);
        });
    },
    getProvinceLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/province`;
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.provinceItems = response.data.data;
            if (scope.defaultData.province) {
              scope.setDefaultObject(scope.provinceItems, 'provinceSelect', 'province');
            }
          }
        })
        .catch(function(error) {
          scope.provinceItems = [];
          console.log(error);
        });
    },
    getAmphoeLists() {
      // if (!this.provinceSelect) return;

      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/amphoe/${this.provinceSelect.id}`;
      this.tambonSelect = '';

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.amphoeAllItems = response.data.data;
            if (scope.provinceSelect) {
              scope.amphoeItems = [];
              scope.tambonItems = [];
              for (let index = 0; index < scope.amphoeAllItems.length; index++) {
                const element = scope.amphoeAllItems[index];
                if (scope.provinceSelect.id == element.province) {
                  scope.amphoeItems.push(element);
                }
              }
              if (scope.defaultData.amphoe) {
                scope.setDefaultObject(scope.amphoeItems, 'amphoeSelect', 'amphoe');
              }
            }

            if (scope.amphoeTempId) {
              scope.amphoeItems.forEach(function(obj) {
                if (scope.amphoeTempId == obj.id) {
                  scope.amphoeSelect = obj;
                }
              });

              scope.amphoeTempId = null;
              scope.getTambonLists();
            }
          }
        })
        .catch(function(error) {
          scope.amphoeItems = [];
          console.log(error);
        });
    },
    getTambonLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/tambon/${this.provinceSelect.id}/${this.amphoeSelect.id}`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.tambonAllItems = response.data.data;
            if (scope.provinceSelect && scope.amphoeSelect) {
              scope.tambonItems = [];
              scope.tambonAllItems.forEach(function(obj) {
                if (
                  scope.provinceSelect.id == obj.province &&
                  scope.amphoeSelect.id == obj.amphoe
                ) {
                  scope.tambonItems.push(obj);
                }
              });
              if (scope.defaultData.tambon) {
                scope.setDefaultObject(scope.tambonItems, 'tambonSelect', 'tambon');
              }
              if (scope.tambonTempId) {
                scope.tambonItems.forEach(function(obj) {
                  if (scope.tambonTempId == obj.id) {
                    scope.tambonSelect = obj;
                  }
                });

                scope.tambonTempId = null;
              }
            }
          }
        })
        .catch(function(error) {
          scope.tambonItems = [];
          console.log(error);
        });
    },
    getChemicalLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/chemical`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.chemicalTypeItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.chemicalTypeItems = [];
          console.log(error);
        });
    },
    getChemicalQuantityLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/chemical_quantity`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.chemicalAmountItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.chemicalAmountItems = [];
          console.log(error);
        });
    },
    getChemicalTimeLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/chemical_time`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.chemicalTimeItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.chemicalTimeItems = [];
          console.log(error);
        });
    },
    getChemicalWindLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/chemical_wind`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.windDirectionItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.windDirectionItems = [];
          console.log(error);
        });
    },
    getFurtherLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/further`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.helpingItems = response.data.data;
            scope.helpingItems = scope.helpingItems.map(item => {
              item.desc = null;
              return item;
            });
            if (scope.defaultData.further_list) {
              scope.defaultData.further_list.forEach(item => {
                const further = this.helpingItems.filter(member => {
                  return member.id === item.id;
                });
                if (further.length === 1) {
                  further[0].desc = item.desc;
                  scope.helpingSelect.push(further[0]);
                }
                scope.defaultData.further_list = null;
              });
            }
          }
        })
        .catch(function(error) {
          scope.helpingItems = [];
          console.log(error);
        });
    },
    getOpsideLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/railway_opside`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.opsideItems = response.data.data;
            scope.opsideItems = scope.opsideItems.map(item => {
              item.desc = null;
              return item;
            });
            if (scope.defaultData.opside_list) {
              scope.defaultData.opside_list.forEach(item => {
                const opside = scope.opsideItems.filter(
                  x => x.id.toString() === item.id.toString()
                );
                if (opside.length) {
                  opside[0].desc = item.desc;
                  scope.opsideSelect.push(opside[0]);
                }
              });
              scope.defaultData.opside_list = null;
            }
          }
        })
        .catch(function(error) {
          scope.opsideItems = [];
          console.error(error);
        });
    },
    toggleDamage(item) {
      const isAdd =
        this.$refs[`damage-${item.id}`][0].isFocused &&
        (item.quantity != null || item.cost != null);
      if (!this.trainDamageSelect.includes(item)) {
        this.trainDamageSelect.push(item);
      }
    },
    toggleFurther(item) {
      const isAdd =
        this.$refs[`further-${item.id}`][0].isFocused && item.desc != null && item.desc != '';
      if (!this.helpingSelect.includes(item)) {
        this.helpingSelect.push(item);
      }
    },
    toggleOpside(item) {
      const isAdd =
        this.$refs[`opside-${item.id}`][0].isFocused && item.desc != null && item.desc != '';
      if (!this.opsideSelect.includes(item)) {
        this.opsideSelect.push(item);
      }
    },
    checkOpside(item) {
      if (!item.desc) {
        const index = this.opsideSelect.findIndex(member => member.id === item.id);
        if (index !== -1) {
          this.opsideSelect.splice(index, 1);
        }
      } else if (!this.opsideSelect.find(member => member.id === item.id)) {
        this.opsideSelect.push(item);
      }
    },
    checkDamage(item) {
      if (!item.quantity && !item.cost) {
        const index = this.trainDamageSelect.findIndex(member => member.id === item.id);
        if (index !== -1) {
          this.trainDamageSelect.splice(index, 1);
        }
      } else if (!this.trainDamageSelect.find(member => member.id === item.id)) {
        this.trainDamageSelect.push(item);
      }
    },
    checkHelping(item) {
      if (!item.desc) {
        const index = this.helpingSelect.findIndex(member => member.id === item.id);
        if (index !== -1) {
          this.helpingSelect.splice(index, 1);
        }
      } else if (!this.helpingSelect.find(member => member.id === item.id)) {
        this.helpingSelect.push(item);
      }
    },
    changeLocation(id) {
      console.log(`change Location => ${id}`);
      const stationFrom = this.telegraphFromItems.filter(x => x.id.toString() === id.toString());
      const item = stationFrom.length === 1 ? stationFrom[0] : {};
      this.getBetweenStationLists();
      if (item.location) {
        this.map.location({
          lat: item.location.latitude,
          lon: item.location.longitude
        });

        const scope = this;
        const amphoe = `0${item.amphoe}`;
        const tumbol = `0${item.tumbol}`;
        scope.amphoeTempId = amphoe.substring(amphoe.length - 2);
        scope.tambonTempId = tumbol.substring(tumbol.length - 2);

        this.provinceItems.forEach(function(obj) {
          if (item.province == obj.id) {
            scope.provinceSelect = obj;
            scope.getAmphoeLists();
          }
        });
      }
    },
    getMapChangeLocation(location) {
      const { lat } = location;
      const { lon } = location;
      const scope = this;
      const url = `https://api.longdo.com/map/services/address?lon=${lon}&lat=${lat}&nopostcode=1&noelevation=1&noroad=1&noaoi=1&nowater=1&key=${process.env.VUE_APP_LONGDO_MAP_KEY}`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200) {
            console.log(response);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    numberWithTwoDecimal($event, num) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || num.indexOf('.') !== -1)) {
        // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (num != null && num.indexOf('.') > -1 && num.split('.')[1].length > 1) {
        $event.preventDefault();
      }
    },
    onlyNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57 || keyCode === 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    splitItemsIntoColumns(items) {
      const cols = 2;
      const columns = [];
      const mid = Math.ceil(items.length / cols);
      for (let col = 0; col < cols; col++) {
        columns.push(items.slice(col * mid, col * mid + mid));
      }
      return columns;
    },
    updateVehicle(value) {
      this.vehicle = value;
    },
    setupAlertDialog(hideIcon, cancelBtn, okBtnCondition, isServiceSuccess, message) {
      this.alertDialog = true;
      this.isServiceSuccess = isServiceSuccess;
      this.cancelBtn = cancelBtn;
      this.hideIcon = hideIcon;
      this.alertDialogMessage = message;
      this.okBtnCondition = okBtnCondition;
    },
    alertDialogOkClicked() {
      this.alertDialog = false;

      switch (this.okBtnCondition) {
        case 'saveAccident':
          this.saveAccident();
          break;
        case 'goToReport':
          this.$router.push({
            name: 'report'
          });
          break;
        default:
          this.alertDialog = false;
      }
    },
    alertDialogCancelClicked() {
      this.alertDialog = false;
    },
    getsurroundValue() {
      let surroundValue;
      if (this.railroadCrossingSelect) return this.railroadCrossingSelect;
      if (this.crossingSelect) return this.crossingSelect;
      return this.surroundSelect ? this.surroundSelect.id : null;
    },
    saveAccident() {
      // if (confirm('ยืนยันการบันทึกข้อมูล?')) {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/form/${
        this.accident !== '' && this.accident !== null && this.accident !== undefined
          ? 'update'
          : 'insert'
      }/railway`;
      const scope = this;
      const messages = null;
      const data = {
        accident_id: this.accident,
        report_date: this.reportDate,
        province_report: this.reportProvinceSelect.id,

        // no.1
        accident_date: this.date,
        accident_time: this.time,

        // no.2
        railway_code: this.roadSelect ? this.roadSelect.id || '' : '',
        km: this.km,
        pillar: this.telegraphNo,
        pillar_from: this.telegraphNo,
        pillar_to: this.telegraphNoSelect,
        pillar_amount: this.postAmount,
        station: this.telegraphFrom,
        station_to: this.stationAreaBtn == 'between' ? this.telegraphTo : '',
        province: this.provinceSelect.id,
        amphoe: this.amphoeSelect.id,
        tambon: this.tambonSelect.id,
        latitude: this.map.location().lat,
        longitude: this.map.location().lon,
        crash_code: this.getsurroundValue(),
        crash_name: this.surroundSelect.needDescription
          ? this.otherSurroundDescription
          : this.surroundSelect.name,
        weather_code: this.weather.id,
        weather_name: this.weather.needDescription
          ? this.otherWeatherDescription
          : this.weather.name,
        dayornight_code: this.light.id,

        // no.3
        train_no: this.trainSelect ? this.trainSelect.id : '',

        // no.4
        dead_male: this.dead.male,
        dead_female: this.dead.female,
        noneserious_injury_male: parseInt(this.injury.male, 10) || '',
        noneserious_injury_female: parseInt(this.injury.female, 10) || '',
        serious_injury_male: this.severed.male,
        serious_injury_female: this.severed.female,

        // no.5
        pattern_code: this.accidentCharacter.id,
        pattern_name: this.accidentCharacter.needDescription
          ? this.otherAccidentCharacterDescription
          : this.accidentCharacter.name,

        // no.6
        vehicle: this.vehicle,
        opside_list: this.opsideSelect,

        // no.7
        damage_list: this.trainDamageSelect,

        // no.8
        further_list: this.helpingSelect,

        // no.9
        chemical_code: this.chemicalTypeSelect,
        chemical_quantity: this.chemicalAmountSelect,
        chemical_time: this.chemicalTimeSelect,
        chemical_wind: this.windDirectionSelect,

        // no.10
        summary: this.description,

        // user
        user_id: localStorage.getItem('user_id') // ,

        // add after
        // gender: this.vehicle && this.vehicle.length ? this.vehicle[0].users[0].gender : ''
      };
      this.axios
        .post(url, qs.stringify(data))
        .then(response => {
          scope.setupAlertDialog(false, false, 'goToReport', true, 'นำข้อมูลเข้าสู่ระบบสำเร็จ');
        })
        .catch(function(error) {
          scope.setupAlertDialog(
            false,
            false,
            'closeAlert',
            false,
            `ดำเนินการไม่สำเร็จ: ${error.response.data.message}`
          );
          console.log(error);
        });
    },
    checkKmLimit() {
      if (this.isOutKmLimit || this.roadSelect === null) {
        this.km = '';
      }
    },
    autocompleteOnBlur(selected, blank, menu, event) {
      this[menu] = false;
    }
  },
  computed: {
    telegraphNoItems() {
      if (this.telegraphNo !== '' && this.telegraphNo !== null) {
        const no = parseInt(this.telegraphNo, 10);
        const items = [];
        items.push((no - 1).toString());
        items.push((no + 1).toString());
        items.push('-');

        return items;
      }
      return [];
    },
    accidentCharacterItemsSplitColumns() {
      return this.splitItemsIntoColumns(this.accidentCharacterItems);
    },
    weatherFirstItems() {
      return this.weatherItems.slice(0, this.weatherItems.length / 2);
    },
    weatherLastItems() {
      return this.weatherItems.slice(this.weatherItems.length / 2);
    },
    lightFirstItems() {
      return this.lightItems.slice(0, this.lightItems.length / 2);
    },
    lightLastItems() {
      return this.lightItems.slice(this.lightItems.length / 2);
    },
    currentDateTime() {
      const currentdate = new Date();
      let datetime = `${currentdate.getDate()}/${currentdate.getMonth() +
        1}/${currentdate.getFullYear()}`;
      datetime += `, ${currentdate.getHours()}:${currentdate.getMinutes()}:${currentdate.getSeconds()}`;
      return datetime;
    },
    trainSelectText() {
      if (this.trainSelect) {
        return `จาก${this.trainSelect.start || ' - '} ถึง${this.trainSelect.end || ' - '} สาย${this
          .trainSelect.line || ' - '} ขา${this.trainSelect.up_down || ' - '} ประเภท${this
          .trainSelect.type || ' - '}`;
      }
      return '';
    },
    roadSelectText() {
      if (this.roadSelect) {
        return `จังหวัด${this.roadSelect.b_province || ' - '} (กม. ${this.roadSelect.km_b ||
          ' - '}) - จังหวัด${this.roadSelect.e_province || ' - '} (กม. ${this.roadSelect.km_e ||
          ' - '})`;
      }
      return '';
    },
    isOutKmLimit() {
      if (this.km !== '' && this.roadSelect) {
        const kmfloat = parseFloat(this.km);
        const b = parseFloat(this.roadSelect.km_b);
        const e = parseFloat(this.roadSelect.km_e);

        return kmfloat < b || kmfloat > e;
      }
      return false;
    },
    kmErrortext() {
      if (this.km !== '' && this.roadSelect) {
        const kmfloat = parseFloat(this.km);
        const b = parseFloat(this.roadSelect.km_b);
        const e = parseFloat(this.roadSelect.km_e);

        if (this.isOutKmLimit) {
          return `กรุณากรอกตัวเลขในช่วง ${b} - ${e}`;
        }
      }

      return '';
    }
  },
  watch: {
    stationAreaBtn(value) {
      this.getBetweenStationLists();
    },
    telegraphNo(value) {
      this.getTelegraphBetweenLocation();
    },
    telegraphNoSelect(value) {
      this.getTelegraphBetweenLocation();
    },
    postAmount(value) {
      this.getTelegraphBetweenLocation();
    },
    provinceSelect() {
      this.getAmphoeLists();
    },
    amphoeSelect() {
      this.getTambonLists();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.map {
  max-height: 400px;
  height: 250px;
}

.layout-height-50 {
  height: 50px;
}

.radio-height-40 {
  height: 40px;
}

.height-200 {
  height: 200px;
}

.max-width-200 {
  max-width: 200px;
}

.topic-number {
  width: 32px;
  height: 32px;
  background-color: var(--v-secondary-base);
  border-radius: 50%;
}

.topic-line {
  width: 1px;
  height: 100%;
  margin-left: 15.5px;
  margin-right: 15.5px;
  background-color: var(--v-secondary-base);

  &.line-mobile {
    width: 2px;
  }

  &.hidden {
    visibility: hidden;
  }
}

.damage-title-column {
  flex-grow: 0.5;
}

.form-4 {
  ::v-deep .col {
    max-width: 120px !important;
  }
}

.updated-user {
  ::v-deep .text-title.col {
    max-width: 200px !important;
  }
}

.input-align-normal {
  ::v-deep .v-input--selection-controls__input {
    align-self: normal !important;
  }
}

.select-as-lebel {
  ::v-deep .v-label {
    top: initial !important;
  }
}

.full-width {
  ::v-deep .v-input__control {
    width: 100% !important;
  }
  ::v-deep .v-label {
    width: 100% !important;
  }
}

.remark {
  color: #ff0000;
}

::v-deep .text-field-as-lebel {
  .v-input__slot {
    margin: 0 !important;
  }
}
</style>
